<template>
  <div class="page-container">
    <a-spin :spinning="loading" size="large" tip="Loading...">
      <supervisor-header
        :kpi-item="kpiItem"
        :current-time="currentTime"
        :colors="colors"
        v-if="kpiItem.length"
      ></supervisor-header>
      <supervisor-content
        v-if="cItems.length"
        :c-items="cItems"
        :max-bom-num="maxBomNum"
        @onNextClick="nextClick"
        @onPreviousClick="previousClick"
        class="spv-content"
      ></supervisor-content>

      <supervisor-footer
        v-if="btnItem.length"
        :fw="fw"
        :btn-item="btnItem"
        @andonModalChange="andonModalChange"
      ></supervisor-footer>
    </a-spin>
  </div>
</template>
<script>
  import SupervisorHeader from './supervisor-header'
  import SupervisorContent from './supervisor-content'
  import SupervisorFooter from './supervisor-footer'
  import { getPageData } from '@/api/supervisor-landing'
  import { message } from 'ant-design-vue'
  export default {
    components: {
      SupervisorHeader,
      SupervisorContent,
      SupervisorFooter,
    },
    provide() {
      return {
        getCurrentPage: () => this.currentPage,
        getUiid: () => this.uiid,
      }
    },
    data() {
      return {
        loading: false,
        uiid: this.$route.params.id,
        total: 0,
        currentPage: 0,
        scrollDelay: 0,
        refreshDelay: 3000,
        autoHideFooter: null,
        isAutoScroll: false,
        pageName: '',
        isRuning: false,
        kpiItem: [],
        cItems: '',
        maBomNum: 3,
        colors: [],
        fw: null,
        btnItem: '',
        initLoop: null,
        initSupervisorLoop: null,
      }
    },
    watch: {
      '$route.params'(v) {
        if (this.$route.name === 'supervisorLandingIndex') {
          this.uiid = v.id
          this.currentPage = 0
          this.pageLoad(true)
        }
      },
      scrollDelay() {},
    },
    created() {
      this.pageLoad(true)
    },
    unmounted() {
      clearInterval(this.initLoop)
      clearInterval(this.initSupervisorLoop)
    },
    methods: {
      previousClick() {
        if (this.currentPage >= 1) {
          this.currentPage = this.currentPage - 1
          this.onLoad(true)
        } else {
          message.warning('There are no more pages to display')
        }
      },
      nextClick() {
        if (this.currentPage < this.total - 1) {
          this.currentPage = this.currentPage + 1
          this.onLoad(true)
        } else {
          message.warning('There are no more pages to display')
        }
      },
      // andon summary 弹窗状态
      andonModalChange(v) {
        console.log(v)
        if (v) {
          clearInterval(this.initLoop)
          clearInterval(this.initSupervisorLoop)
        } else {
          this.pageLoad()
        }
      },
      async pageLoad(showLoading = false) {
        //页面翻屏
        await this.onLoad(showLoading)

        this.initLoop = setInterval(() => {
          if (this.isAutoScroll && this.refreshDelay > this.scrollDelay) {
            //如果轮循时间大于滚屏时间就没有必要再轮循了。
            clearInterval(this.initLoop)
          } else if (!this.isRuning) {
            this.onLoad()
          }
        }, this.refreshDelay)
        if (this.isAutoScroll && this.total > 1) {
          this.initSupervisorLoop = setInterval(() => {
            if (this.isRuning) return
            this.currentPage =
              this.currentPage >= this.total - 1 ? 0 : this.currentPage + 1
            this.onLoad()
          }, this.scrollDelay)
        }
      },

      onLoad(showLoading = false) {
        return new Promise((resolve) => {
          this.isRuning = true
          this.loading = showLoading
          getPageData({ id: this.currentPage, uiid: this.uiid })
            .then((res) => {
              const { totalPages, config, pageName, data, currentTime } =
                res.body
              this.total = totalPages
              this.currentPage = config.pageIndex
              this.scrollDelay = config.scrollDelay
              this.refreshDelay = config.refreshDelay
              this.autoHideFooter = config.autoHideFooter
              this.isAutoScroll = config.isAutoScroll
              this.pageName = pageName

              this.kpiItem = data.kpi
              this.cItems = JSON.stringify(data.line.data)
              this.maxBomNum = data.line.maxBomNum
              this.colors = data.pulse
              this.currentTime = currentTime
              this.fw = data.fw
              this.btnItem = data.footer.data
            })
            .catch((e) => {
              console.log(e)
            })
            .finally(() => {
              this.loading = false
              this.isRuning = false
              resolve()
            })
        })
      },
    },
  }
</script>
<style lang="less" scoped>
  .page-container {
    height: calc(100vh - 32px);
    .spv-content {
      height: calc(100vh - 50px - 32px - 118px);
      overflow: auto;
      overflow-x: hidden;
    }
    .ant-spin-spinning {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%);
    }
  }
</style>
